import { accountDataStore } from "../../../store/Store"
import useGetFetch from '../../../hooks/useGetFetch';
import Loading from "../../../components/Loading";
import ErrorDisplay from "../../../components/ErrorDisplay";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { useEffect } from "react";
import ReceivedInvoiceList from "./ReceievedInvoiceList";




export default function AccountReceivedInvoices() {
  const setAccountReceivedInvoices = accountDataStore(data => data.setAccountReceivedInvoices)

  const {setInvoiceTarget} = useOutletContext()
  const {invId} = useParams("invId")
  useEffect(() => {
    setInvoiceTarget("Received")
  })
  const {isPending, error, statusCode} = useGetFetch(`${process.env.REACT_APP_BACKEND}/lc/account-invoices`, setAccountReceivedInvoices)
  
  if (isPending) {
    return <Loading />
  } else if (error) {
    return <ErrorDisplay message={error} code={statusCode} />
  }
  return (
    <div className="container-fluid">
      {!invId && <ReceivedInvoiceList />}
      <Outlet />
    </div>
  )
}